import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FvrZeropaySupportPopupService } from '../fvr-zeropay-support-popup.service';

@Component({
  selector: 'lib-dialog-email',
  templateUrl: './dialog-email.component.html',
  styleUrls: ['./dialog-email.component.css'],
})
export class DialogEmailComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private supp: FvrZeropaySupportPopupService,
    private dialogRef: MatDialogRef<DialogEmailComponent>,
    private http: HttpClient
  ) {}

  public isMobile = false;
  public loading = false;
  public success = false;

  public files!: FileList;

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 720;

    if (this.data.prefilledMessage) {
      this.form.controls.message.setValue(this.data.prefilledMessage);
      this.form.updateValueAndValidity();
    }

    if (this.data.prefilledName) {
      this.form.controls.name.setValue(this.data.prefilledName);
      this.form.updateValueAndValidity();
    }

    if (this.data.prefilledEmail) {
      this.form.controls.emailAddress.setValue(this.data.prefilledEmail);
      this.form.updateValueAndValidity();
    }

    if (this.data.selectedOption) {
      const topic = this.data.topicOptions[this.data.selectedOption];
      this.form.controls.reason.setValue(topic);
      this.form.updateValueAndValidity();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = window.innerWidth <= 720;
  }

  public form = new FormGroup({
    idNumber: new FormControl(null, Validators.pattern('^[0-9]+$')),
    name: new FormControl(null, [
      Validators.required,
      Validators.pattern('^[a-zA-Z ]+$'),
    ]),
    cellNumber: new FormControl(null, [
      Validators.required,
      Validators.pattern('^[0-9]+$'),
      Validators.minLength(10),
    ]),
    emailAddress: new FormControl(null, [
      Validators.required,
      Validators.email,
    ]),
    reason: new FormControl(null, [Validators.required]),
    message: new FormControl(null, [Validators.required]),
  });

  public fileChange($event: any) {
    this.files = $event.target.files as FileList;
  }

  toBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  async submit(form: FormGroup) {
    if (form.valid) {
      this.loading = true;

      const response: any = await this.supp.getTemplate();
      let template = response.content;
      let message = form.value.message;

      if (this.data.allowFileUploads) {
        if (this.files.length > 0) {
          message += '<br/><p>Attached Files</p>';

          for (let i = 0; i < this.files.length; i++) {
            let formData = new FormData();
            formData.append(
              'requestFile',
              this.files.item(i) as File,
              (this.files.item(i) as File).name
            );
            formData.append(
              'collection',
              JSON.stringify(['Zeropay', 'Contact', 'Files'])
            );

            const response: any = await this.http
              .post(
                'http://drive.fevertreefinance.co.za/file/upload',
                formData,
                {
                  headers: new HttpHeaders().append(
                    'app-key',
                    'M2U2ZWMyNDYtYWMyMi00ODY0LThlOGMtYWMzMWVhZDIxYjg5'
                  ),
                }
              )
              .toPromise();
            message += `<a href="http://drive.fevertreefinance.co.za/file/fetch/${
              response.reference
            }" target="_blank">Download - ${
              (this.files.item(i) as File).name
            }</a><br/>`;
          }
        }
      }

      template = decodeURIComponent(template);
      template = template.replace('[CUSTOMER_NAME]', form.value.name);
      template = template.replace(
        '[CUSTOMER_EMAIL]',
        `${form.value.emailAddress}; Cell - ${form.value.cellNumber};${
          form.value.idNumber ? form.value.idNumber : '(ID Not Provided)'
        }`
      );
      template = template.replace('[REASON]', form.value.reason);
      template = template.replace('[MESSAGE]', message);

      await this.supp.sendMail({
        to: this.data.emailTo,
        subject: `Support Mail - ${this.data.sourceName}`,
        body: template,
        cc: this.data.cc,
        bcc: this.data.bcc,
      });

      this.loading = false;
      this.success = true;

      setTimeout(() => {
        this.dialogRef.close();
      }, 1000);
    }
  }
}
